<template>
    <div>
        <div class="d-flex">
        <!-- <div class="form-inline mr-auto">
            <div class="form-group mb-2">
            <label class="mr-2">Filtro:</label> <input type="text" class="form-control mr-2" placeholder="buscar"
                [(ngModel)]="filtroLista">
            </div>
        </div> -->
        <div style="padding-bottom:10px">
            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold 
            py-2 px-4 rounded focus:outline-none focus:shadow-outline" 
            @click="openNewModal">
            <font-awesome-icon icon="plus-circle" />&nbsp;
            Novo Server
            </button>
        </div>
        </div>
        <!-- <h3>Filtro: {{filtroLista}}</h3> -->
        <table class="table-auto min-w-full bg-white text-left w-full border-collapse
            shadow-md rounded mb-4
        ">
            <thead class="bg-blue-800 text-white">
                <tr class="border-b">
                <th class="pl-4">#</th>
                <th class="w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Nome</th>
                <th class="w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">HostName</th>
                <th class="text-left py-3 px-4 uppercase font-semibold text-sm">Inserido Em</th>
                <th colspan="2" class="text-left py-3 px-4 uppercase font-semibold text-sm">Opções</th>
                </tr>
            </thead>

            <tbody v-if="servers.length > 0">
                <tr v-for="server in servers" :key="server.token"
                class="border-b hover:bg-orange-100 bg-gray-100"
                >
                <td class="pl-4">
                    <!-- {{server.id}} -->
                    <a  
                        tooltip="Visualizar Servidor" class="
                        bg-transparent hover:bg-blue-500 text-blue-700 font-semibold 
                        hover:text-white py-1 px-2 
                        border border-blue-500 hover:border-transparent rounded
                         inline-flex items-center cursor-pointer" >
                        <font-awesome-icon class="fill-current w-4 h-4" icon="search-plus" />
                    </a>
                </td>
                <td>{{server.name}}</td>
                <td>{{server.hostName}}</td>
                <td>{{server.createdAt | sbformatdate}}</td>
                <td class="px-2 py-3 flex justify-end">
                    <button class="mr-2 
                        bg-transparent hover:bg-blue-500 text-blue-700 font-semibold 
                        hover:text-white py-1 px-2 
                        border border-blue-500 hover:border-transparent rounded
                         inline-flex items-center cursor-pointer" tooltip="Editar" 
                        >
                        <font-awesome-icon class="fill-current w-4 h-4" icon="pencil-alt" />
                    </button>
                    <button class="
                        bg-transparent hover:bg-red-500 text-red-700 font-semibold 
                        hover:text-white py-1 px-2 
                        border border-red-500 hover:border-transparent rounded
                         inline-flex items-center cursor-pointer
                    " tooltip="Excluir" 
                        >
                        <font-awesome-icon class="fill-current w-4 h-4" icon="trash-alt" />
                    </button>
                </td>
                </tr>
            </tbody>
            <tfoot v-if="servers.length == 0">
                <tr>
                <td colspan="5" class="text-center">
                    <h4>
                    Nenhum Servidor encontrado!
                    </h4>
                </td>
                </tr>
            </tfoot>
        </table>
        <pagination :pagination="paginationData" @paginate="fetchServers" :offset="offset" />

        <!-- <t-modal ref="newServerModal">New Server</t-modal> -->
        <Modal :open="newShow" @close="closeNewForm">
          <div class="xs:w-104 w-96 bg-white rounded-lg">
            <div class="modal-header border-b-2 border-gray-200 px-4 pt-4 pb-4">
                <h2 class="font-semibold text-gray-900 text-xl leading-tight">Novo Servidor</h2>
            </div>
            <div class="modal-body text-gray-700 shadow-2xl px-4 py-4">
                <form class="">
                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="name">
                            Nome do Servidor
                        </label>
                        <input class="shadow appearance-none border rounded 
                            w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none 
                            focus:shadow-outline" 
                            v-model="formNew.name"
                            :class="{ 'border-red-500': formNew.errors.has('Name') }"
                            id="name" type="text" placeholder="Nome do Servidor">
                        <has-error :form="formNew" field="Name"></has-error>
                    </div>
                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="hostName">
                            Hostname
                        </label>
                        <input class="shadow appearance-none border 
                            rounded w-full py-2 px-3 text-gray-700 mb-3 
                            leading-tight focus:outline-none focus:shadow-outline" 
                            :class="{ 'border-red-500': formNew.errors.has('hostName') }"
                            v-model="formNew.hostName"
                            id="hostName" type="text" placeholder="Hostname">
                            <has-error :form="formNew" field="hostName"></has-error>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
              <button @click="closeNewForm" class="btn-cancel">
                Cancelar
              </button>
              <button type="button" @click="onSubmitNew" class="btn-success">
                Salvar Alterações
              </button>
            </div>
          </div>
        </Modal>
    </div>
</template>

<script>

import Pagination from "./../components/Pagination.vue"
import Modal from "./../components/Modal.vue"
import axios from 'axios'
import Form from './../shared/Form'

//import dayjs from 'dayjs'

export default {
    data(){
        return {
            loading: false,
            servers: [],
            offset: 4,
            paginationData: {
                TotalCount:1,
                PageSize:10,
                CurrentPage:1,
                TotalPages:1,
                HasNext:false,
                HasPrevious:false
            },
            formNew: new Form({
                name: '',
                hostName: ''
            }),
            newShow: false
        }
    },
    components: {
        pagination: Pagination,
        Modal
    },
    created: function(){
        this.fetchServers();
    },
    methods: {
        fetchServers: function(){
            //console.log('this.paginationData: ', this.paginationData);
            let currentPage = this.paginationData.CurrentPage;
            let pageNum = currentPage ? currentPage : 1;

            axios.get(`/servers?page=${pageNum}`)
                .then(response => {
                    //console.log(response.headers);
                    this.paginationData = JSON.parse(response.headers['x-pagination']);
                    this.servers = response.data;
                }).catch(error => alert(error));
        },
        openNewModal(){
            this.formNew.reset();
            this.formNew.clear();
            this.newShow = true;
            //this.$refs.newServerModal.show();
        },
        closeNewForm(){
            this.formNew.reset();
            this.formNew.clear();
            this.newShow = false;
            //this.$refs.newServerModal.show();
        },
        onSubmitNew() {
            this.formNew.post('/servers')
                .then(() => {
                    this.fetchServers();
                    //make a swal alert or a toast with sucess message and close the modal
                    this.closeNewForm();
                }
                );
        }
    }
}
</script>